import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class AnimationPreferences {
    static init() {
        this.body = document.body;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.animationCookieName = 'a42-ac-animations';
        this.animationsEnabled = this.readAnimationCookie();

        this.applyInitialPreferences();
        window.addEventListener('load', this.update.bind(this));
    }

    static update() {
        this.refreshScrollTriggers();
        console.log('AnimationPreferences updated');
    }

    static handleAnimationChange(selectedValue) {
        if (selectedValue === 'a42-ac-enable-animations') {
            this.enableAnimations();
        } else {
            this.disableAnimations();
        }
    }

    static applyInitialPreferences() {
        if (this.animationsEnabled === 'a42-ac-disable-animations' || this.prefersReducedMotion) {
            this.disableAnimations();
        }
    }

    static enableAnimations() {
        this.body.classList.remove('no-animations');
        this.createAnimationCookie('a42-ac-enable-animations');
    }

    static disableAnimations() {
        // this.body.classList.add('no-animations');
        this.createAnimationCookie('a42-ac-disable-animations');
        this.killScrollTriggers();
    }

    static killScrollTriggers() {
        const triggers = ScrollTrigger.getAll();
        if (!triggers.length) return;

        triggers.forEach(trigger => trigger.kill());
        console.log('All scrollTriggers killed');
    }

    static refreshScrollTriggers() {
        const triggers = ScrollTrigger.getAll();
        if (!triggers.length) return;

        triggers.forEach(trigger => trigger.refresh());
        console.log('All scrollTriggers refreshed');
    }

    static shouldAnimate() {
        return !(this.animationsEnabled === 'a42-ac-disable-animations' || this.prefersReducedMotion);
    }

    static createAnimationCookie(value) {
        const date = new Date();
        date.setTime(date.getTime() + (180 * 24 * 60 * 60 * 1000)); // 180 jours
        document.cookie = `${this.animationCookieName}=${value}; expires=${date.toUTCString()}; path=/`;
        this.animationsEnabled = value;
    }

    static readAnimationCookie() {
        const nameEQ = `${this.animationCookieName}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return 'a42-ac-enable-animations'; // Valeur par défaut
    }
}